var map = {
	"./cell_size_1.svg": "dbe6",
	"./cell_size_2.svg": "5f76",
	"./cell_size_3.svg": "8a1e",
	"./cell_size_4.svg": "9d8f",
	"./locker_is_full.svg": "7074",
	"./locker_no_compartment.svg": "e22b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "89fe";